import { Badge, Flex } from '@radix-ui/themes'
import { badgeColors } from '@/shared/constants/constants'
import { TrackManagerApplication } from '@/types/shared'
import ApplicationReviewForm from '@/shared/track_manager/ApplicationReviewForm'
import ExpandableCards from '@/shared/manager/ExpandableCards'

interface Props {
  applications: TrackManagerApplication[]
}

/** The mobile applications queue. */
export default function ApplicationsCards({ applications }: Props) {
  return (
    <ExpandableCards
      items={applications}
      getKey={(application) => application.id}
      emptyMessage="No applications here."
      renderSummary={(application) => (
        <Flex direction="column" gap="1">
          <p className="truncate text-[15px] font-bold leading-tight">
            {application.participant.name}
          </p>
          <span className="truncate text-sm text-gray11">
            {application.event_name} · {application.event_date}
          </span>
          <Flex gap="2" mt="1" wrap="wrap">
            <Badge
              variant="soft"
              color={badgeColors[application.status]}
              style={{ textTransform: 'capitalize' }}
            >
              {application.status}
            </Badge>
            {application.credential && (
              <Badge
                variant="soft"
                color={badgeColors[application.credential.status]}
                style={{ textTransform: 'capitalize' }}
              >
                {application.credential.category}: {application.credential.status}
              </Badge>
            )}
          </Flex>
        </Flex>
      )}
      renderDetail={(application) => <ApplicationReviewForm application={application} compact />}
    />
  )
}
